module.exports = __webpack_public_path__ + "img/upload.53515099.svg";